import { useMutation, useQueryClient } from '@tanstack/react-query';

import { WORKFLOW_TYPE } from '@/types/workflowConst';

import { createNotification } from './create-notification';
import { deleteNotification } from './delete-notification';
import { notificationQueryKeys } from './notification.queries';
import { updateNotification } from './update-notification';

/**
 * Signal Alert 생성 mutation
 */
export function useCreateSignalAlertMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createNotification,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: notificationQueryKeys.list([WORKFLOW_TYPE.SIGNAL_ALERT]),
      });
    },
  });
}

/**
 * Signal Alert 수정 mutation
 */
export function useUpdateSignalAlertMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateNotification,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: notificationQueryKeys.list([WORKFLOW_TYPE.SIGNAL_ALERT]),
      });
    },
  });
}

/**
 * Signal Alert 삭제 mutation
 */
export function useDeleteSignalAlertMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteNotification,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: notificationQueryKeys.list([WORKFLOW_TYPE.SIGNAL_ALERT]),
      });
    },
  });
}
